"use client";

import { ISiteConfigLayouts, SignupLayoutEnum } from "@finbackoffice/fe-core";
import classNames from "classnames";
import { CpfSignupContext, useRuntimeConfig, useSiteConfig } from "@finbackoffice/site-core";
import { ConfigContextV2, ModalsContextV2 } from "contexts";
import { FC, useContext } from "react";
import Signup from "components/account/signup/Signup";
import Modal from "components/base/modal/Modal";
import { ModalStyleTypeEnum } from "components/base/modal/constants/modal-config";
import { ModalTypes } from "utils/constants";
import { useDevice } from "hooks";
import { SignupDisabledContent } from "./disabled/SignupDisabledContent";
import styles from "./signup-modal.module.sass";

const SignupModal: FC = () => {
    const siteLayoutsConfig = useSiteConfig<ISiteConfigLayouts>("layouts");
    const { signupEnabled } = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const { isMobileDevice } = useDevice();
    const { step } = useContext(CpfSignupContext);
    const { siteRegistrationConfig } = useContext(ConfigContextV2);
    const { signupModalRef } = useContext(ModalsContextV2);
    const isCpfSignupLayout = [
        SignupLayoutEnum.CPFSignup,
        SignupLayoutEnum.CPFSignup1Step,
        SignupLayoutEnum.CPFSignupKyc,
    ].includes(siteLayoutsConfig._signup.type);
    const isAfroSignupLayout = siteLayoutsConfig._signup.type === SignupLayoutEnum.Afro;
    const isDefaultSignUpLayout = siteLayoutsConfig._signup.type === SignupLayoutEnum.Default;

    return (
        <Modal
            ref={signupModalRef}
            type={ModalTypes.SIGNUP}
            styleConfigType={ModalStyleTypeEnum.SignUp}
            styleClass={classNames(
                styles.signupCompact,
                isDefaultSignUpLayout && styles.signupDefault,
                isCpfSignupLayout && styles.signupCpf,
                isAfroSignupLayout && styles.signupAfro,
            )}
            closeButton={step !== "second" || !siteRegistrationConfig?.auto_id_verification}
            animateVariant={signupEnabled && isMobileDevice ? "bottom" : "opacity"}>
            {signupEnabled ? (
                <Signup
                    isDefault={isDefaultSignUpLayout}
                    noPadding={isCpfSignupLayout || isAfroSignupLayout}
                />
            ) : (
                <SignupDisabledContent onClose={() => signupModalRef.current?.close()} />
            )}
        </Modal>
    );
};

export default SignupModal;
